import styled, { css, keyframes } from 'styled-components';

interface IStatContainer {
  isRedCorner: boolean;
  r: number;
  g: number;
  b: number;
}

interface IStatCard {
  isRedCorner: boolean;
}

const appear = (isRedCorner: boolean) => keyframes`
  from {
    opacity: 0;
    ${
      isRedCorner
        ? css`
            transform: translateX(-100px);
          `
        : css`
            transform: translateX(100px);
          `
    }
  }
  to {
    opacity: 1;
    transform: translateX(0)
  }
`;

export const Container = styled.div<IStatContainer>`
  //padding: ${({ isRedCorner }) =>
    isRedCorner ? '0 0 0 160px' : '0 160px 0 0'};

  justify-content: ${({ isRedCorner }) => (isRedCorner ? 'right' : 'left')};
  border-radius: ${({ isRedCorner }) =>
    isRedCorner ? '0px 16px 0px 0px' : '16px 0px 0px 0px'};
  animation: ${(props) => appear(props.isRedCorner)} 1.5s;
  max-width: 712px;
  display: flex;
    flex-direction: ${({ isRedCorner }) =>
      isRedCorner ? 'row-reverse' : 'row'};
    flex-wrap: wrap;
  background-color: rgba(
    ${(props) => props.r},
    ${(props) => props.g},
    ${(props) => props.b},
    1
  );

  .fields{
    display: flex;
    flex-direction: ${({ isRedCorner }) =>
      isRedCorner ? 'row-reverse' : 'row'};
    flex-wrap: wrap;
    width: 100%;
  }
  .fighter-name {
    display: flex;
    flex-direction: ${({ isRedCorner }) =>
      isRedCorner ? 'row' : 'row-reverse'};
    flex-wrap: wrap;
    // width: 100%;
    max-width: 552px;
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 120% */
    margin: 10px 0;
    margin-right: 50px;

  }

  .header {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: auto 30px;
    max-width: 552px;
  }
`;

export const FieldContainer = styled.div<IStatCard>`
  width: 27%;
  max-width: 152px;
  // width: 152px;
  // padding: 2% 1%;
  margin: ${({ isRedCorner }) =>
    isRedCorner ? '20px 32px 20px 0' : '20px 0 20px 32px'};
  display: flex;
  align-items: center;
  flex-direction: column;
  font-family: 'Montserrat';
  // height: 232px;
  border-radius: 0.5rem 0.5rem 0rem 0rem;

  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  // border: 1px solid black;
  &:hover {
    opacity: 0.8;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
  }

  span {
    font-size: 20px;
    text-align: center;
    min-height: 5%;
    max-height: 25%;
    // color: #f4f4f4;
  }

  img {
    width: 50%;
  }

  .chart {
    width: 80%;
  }

  .stat {
    border-radius: 0.5rem 0.5rem 0rem 0rem;

    width: 100%;
    min-width: 100px;
    // min-height: 70%;
    height: 120px;
    // padding: 10% 5%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    background-color: #ffffff;
  }
  .stat-name {
    height: 72px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    color: #2a2a2a;
    background-color: #e4e9f2;
  }
  .chart-line {
    height: 40px;
    background-color: #c62fff;
    width: 100%;
    text-align: right;
    font-size: 28px;
    line-height: 34px;
  }
`;
